import React from "react";
import styles from './modal.module.css';
import {Modal as BootStrapModal} from "react-bootstrap";
import {DangerButton, PrimaryButton} from "../input/inputs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark} from "@fortawesome/free-solid-svg-icons";

export default function Modal({
    show,
    setter,
    name,
    description,
    children,
    buttonName,
    onClick,
    size,
    buttons,
    otherSetter,
    hideClose,
    headerClassName,
    titleClassName,
    dialogClassName,
}) {
    return (
        <BootStrapModal
            show={show}
            className={styles.container}
            centered={true}
            size={size}
            dialogClassName={dialogClassName}
        >
            <div className={headerClassName || styles.header}>
                <div className={'d-flex justify-content-between align-items-center'}>
                    <div className={titleClassName || undefined}>{name}</div>
                    <FontAwesomeIcon
                        className={styles.closeHeaderIcon}
                        icon={faCircleXmark}
                        onClick={() => setter(false)}
                        role={'button'}
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setter(false);
                            }
                        }}
                        aria-label="Cerrar"
                    />
                </div>
                {description ? <div>{description}</div> : null}
            </div>

            <div style={{
                paddingLeft: '1rem',
                paddingRight: '1rem',
            }}>
                <div className={styles.body}>
                    {children}
                </div>

                <div className={styles.footer}>
                    <div>
                        {buttonName && <PrimaryButton name={buttonName} onClick={onClick}/>}
                    </div>
                    <div>
                        {buttons}
                    </div>
                    {!hideClose && <DangerButton onClick={otherSetter ? () => otherSetter() : () => setter(false)} name={'Cerrar'}/>}
                </div>
            </div>
        </BootStrapModal>
    );
}